
export enum ExceptionCategoryCd {
	OPTIMIZER = 'Optimizer',
	SCO = 'SCO'}

